import {alpha} from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(1.25, 1.25),
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
    },
    selectedRow: {
        background: theme.palette.grey[400],
    },
    iconButton: {
        width: 40,
        height: 40,
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: alpha(theme.palette.background.default, 0.25),
        },
    },
    gridContainer: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    treeRows: {
        backgroundColor: theme.palette.grey[100],
    },
    root: {
        borderRadius: '4px 4px 0 0',
        '& .MuiDataGrid-row.Mui-even:not(:hover)': {
            backgroundColor: 'rgba(10, 8, 8, 0.04)',
        },
        '& .MuiInputBase-input': {
            padding: theme.spacing(0.5, 1),
        },
        '& .MuiDataGrid-columnHeader': {
            padding: theme.spacing(0.5, 1.5),
            fontSize: 14,
            '& .MuiDataGrid-columnHeaderTitleContainer': {
                '& .MuiDataGrid-columnHeaderTitle': {
                    flex: '1 1',
                    fontWeight: 'bold',
                },
                padding: 0,
                flexDirection: 'row'
            },
        },
        '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none !important',
        },
        '& .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none !important',
        },
        '& .checkbox--cell': {
            'justify-content': 'flex-start',
            '& .MuiFormControlLabel-root': {
                margin: 0,
            },
        },
        '& .editable--full--cell': {
            paddingLeft: '1px !important',
            paddingRight: '2px !important',
            '& .MuiFormControl-root': {
                margin: 0,
                '& .MuiInputBase-root': {
                    padding: 0,
                    '& input[type=text] ': {
                        padding: '4px 8px'
                    }
                }
            }
        },
        '& .textfield--cell': {
            '& .MuiFormControlLabel-root': {
                margin: 0,
            },
            '& .MuiFormControl-marginDense': {
                margin: 0,
            },
        },
        '& .MuiTablePagination-toolbar': {
            minHeight: 'fit-content',
            '& .MuiSvgIcon-colorAction': {
                color: 'white',
            },
        },
        '& p.MuiTablePagination-displayedRows': {
            marginBlockStart: theme.spacing(1.2),
            marginBlockEnd: theme.spacing(1.2),
        },
        '& p.MuiTablePagination-selectLabel': {
            marginBlockStart: theme.spacing(1.2),
            marginBlockEnd: theme.spacing(1.2),
        },
        '& .autocomplit--cell': {
            '& .MuiFormControlLabel-root': {
                margin: 0,
            },
        },
        '&.MuiDataGrid-root': {
            padding: theme.spacing(0),
            paddingBottom: theme.spacing(1.5),
        },
        '& .MuiDataGrid-pinnedColumns': {
            boxShadow: 'none',
        },
        // '& .MuiCircularProgress-root': {
        //   zIndex: theme.zIndex.speedDial
        // },
        '& .MuiDataGrid-pinnedColumnHeaders': {
            boxShadow: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-row.Mui-selected': {
            backgroundColor: theme.palette.grey[200],
        },
        '& .MuiDataGrid-cell:focus': {
            outline: 'none',
        }, '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
        },
        ' & .MuiDataGrid-cell--textRight': {
            'justify-content': 'flex-start'
        },
        '& .MuiDataGrid-cell': {
            padding: theme.spacing(0.5, 1.5),
        },
        '& .MuiDataGrid-viewport': {
            marginBottom: '50px',
        },
        '& .MuiDataGrid-columnSeparator': {
            cursor: 'col-resize',
        },
    },
    divider: {
        background: theme.palette.secondary.main,
        border: `0.1em solid ${theme.palette.secondary.main}`,
    },
    headerText: {
        flexGrow: 1,
        fontWeight: 'bold',
        padding: theme.spacing(0.5, 0.5),
        whiteSpace: 'nowrap',
    },
    toolbar: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: '0 .5rem 0 0.5rem',
        height: 48,
        borderRadius: '4px 4px 0 0',
    },
    pagination: {
        fontSize: '12px',
        '& :is(.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows)':
            {
                fontSize: '12px',
            },
        color: theme.palette.secondary.main,
        '& .MuiInputBase-root': {
            marginRight: theme.spacing(1),
            marginLeft: theme.spacing(0.2),
        },
        '& .MuiTablePagination-actions': {
            'padding-left': theme.spacing(0.2),
            marginLeft: theme.spacing(0.2),
            '& .MuiButtonBase-root': {
                width: 40,
                height: 40,
                backgroundColor: 'transparent',
                padding: 0,
                '&:hover': {
                    backgroundColor: alpha(theme.palette.background.paper, 0.25),
                },
            },
        },
        '& .MuiTablePagination-toolbar': {
            'padding-left': theme.spacing(0.2),
        },
    },
}));

export const useDataGridEditPanelStyles = makeStyles((theme) => ({
    formGroup: {
        border: 'none',
        margin: 0,
        padding: 0,
        display: 'inline',
    },
    resizeHandle: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        opacity: 0.2,
        zIndex: 2,
        boxSizing: 'border-box',
        backgroundClip: 'padding-box',
        width: `calc((2 * ${theme.spacing(2)}) + 1px)`,
        margin: `0 -${theme.spacing(2)}`,
        cursor: 'col-resize',
        transition: 'border 2s ease, width 250ms ease, opacity 250ms ease',
        '&:hover': {
            borderLeftColor: 'rgba(0, 0, 0, 0.5)',
            borderRightColor: 'rgba(0, 0, 0, 0.5)',
        },
        '&.hidden': {
            opacity: 0,
            pointerEvents: 'none',
            width: 0,
        },
    },
    form: {
        display: 'flex',
        overflow: 'hidden',
        height: '100%',
        flexDirection: 'column',
        marginRight: 10,
        borderRadius: '4px 4px 0 0',
    },

    mainHeader: {
        display: 'flex',
        color: 'white',
        alignItems: 'center',
        backgroundColor: theme.palette.primary.dark,
        padding: theme.spacing(0.45, 1),
        zIndex: theme.zIndex.modal + 500
    },
    headerText: {
        flexGrow: 1,
        fontWeight: 'bold',
    },
    saveButton: {
        fontWeight: 'bold',
        textTransform: 'capitalize',
        paddingTop: 0,
        paddingBottom: 0,
        margin: 2.5,
        '&.MuiButton-root.Mui-disabled': {
            color: theme.palette.common.white,
            opacity: '.5',
            border: `1px solid ${alpha(theme.palette.background.paper, 0.5)}`,
        },
        '&.MuiButton-root.MuiButton-outlined': {
            border: `1px solid ${alpha(theme.palette.background.paper, 0.7)}`,
            color: alpha(theme.palette.background.paper, 0.8),
        },
        '&.MuiButton-root.MuiButton-contained': {
            color: theme.palette.primary.dark,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(1),
        overflowY: 'auto',
        margin: 0,
        flexGrow: 1,
    },
    btnLeft: {
        float: 'left',
        padding: theme.spacing(1),
    },
    btnRight: {
        float: 'right',
        padding: theme.spacing(1),
    },
    iconClose: {
        width: 40,
        height: 40,
        padding: theme.spacing(0.5),
        float: 'right',
        '&:hover': {
            backgroundColor: alpha(theme.palette.background.paper, 0.25),
        },
    },
    drawer: {
        maxWidth: `calc(100vw - ${theme.spacing(8)})`,
        backgroundColor: theme.palette.grey[100],
        minWidth: theme.spacing(50),
        top: 59,
        bottom: 0,
        height: 'unset',
        paddingLeft: 0,
        zIndex: 1,
        boxShadow: theme.shadows[16],
        borderRadius: '4px 4px 0 0',
        transition: theme.transitions.create('width'), // 'width 250ms ease, min-width 250ms ease',
    },
}));
